import DashboardLogoImg from "@/assets/dashboard.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const DashboardLogo = (props: Props) => (
  <LogoImage imgSrc={DashboardLogoImg} alt="Dashboard Logo" size="navbar" {...props} />
);
